import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export const VendorMappingDialogPrompt = (props) => {
	return (
		props.isOpen && <Dialog
			open={props.isOpen}
			aria-labelledby="draggable-dialog-title"
		>
			<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
				{props.title }
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{props.message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button autoFocus onClick={props.onClose} color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}